import React from 'react'
import PropTypes from 'prop-types'

class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
    this.handleRefresh = this.handleRefresh.bind(this)
  }

  static getDerivedStateFromError () {
    return { hasError: true }
  }

  componentDidCatch (error, info) {
    if (global.console && global.console.error) {
      global.console.error('A section of the page failed to render:', error, info)
    }
  }

  handleRefresh () {
    if (global.location && typeof global.location.reload === 'function') {
      global.location.reload()
    }
  }

  render () {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }
      return (
        <div style={{ padding: '2rem', textAlign: 'center' }}>
          <h4>Something went wrong loading this section.</h4>
          <p>Please refresh the page and try again. If the problem persists, contact support.</p>
          <button type='button' className='btn btn-primary' onClick={this.handleRefresh}>Refresh</button>
        </div>
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node
}

export default ErrorBoundary
